// extracted by mini-css-extract-plugin
module.exports = {"container":"ThreeLoadingDots-container-3QjWE0","opacity":"ThreeLoadingDots-opacity-15s_cF"};